import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1246.2464,64 L1155.7504,154.496 L1633.7024,632.448 L1042.8544,632.448 C467.8784,632.448 0.0384,1100.416 0.0384,1675.392 L0.0384,1784.448 L128.0384,1784.448 L128.0384,1675.392 C128.0384,1170.816 538.4064,760.448 1042.8544,760.448 L1633.7024,760.448 L1155.7504,1238.528 L1246.2464,1329.024 L1878.6944,696.448 L1246.2464,64 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconForwardLine = /*#__PURE__*/function (_Component) {
  _inherits(IconForwardLine, _Component);

  var _super = _createSuper(IconForwardLine);

  function IconForwardLine() {
    _classCallCheck(this, IconForwardLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconForwardLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconForward",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconForwardLine.displayName = "IconForwardLine";
  return IconForwardLine;
}(Component);

IconForwardLine.glyphName = 'forward';
IconForwardLine.variant = 'Line';
IconForwardLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconForwardLine;
export { IconForwardLine };